export const ADD_ENTITIES = "ADD_ENTITIES";
export const DELETE_ROW = "DELETE_ROW";
